export type MediaType = "movie" | "tv" | "variety" | "anime";

export interface Episode {
  no: number;
  title: string;
  duration: string;
  synopsis: string;
}

export interface Movie {
  id: string;
  title: string;
  year: number;
  type: MediaType;
  region: string;
  genres: string[];
  rating: number;
  heat: number;
  director: string;
  cast: string[];
  duration: string;
  status: string;
  totalEpisodes?: number;
  episodes: Episode[];
  synopsis: string;
  poster: string;
  tags: string[];
  updatedAt: string;
}

export const movies: Movie[] = [
  {
    id: "longye-jiangming",
    title: "长夜将明",
    year: 2025,
    type: "movie",
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.7,
    heat: 9840,
    director: "程子昂",
    cast: ["段奕辰", "苏叶", "刘维安"],
    duration: "128分钟",
    status: "已上映",
    episodes: [],
    synopsis:
      "一桩沉寂十二年的旧案在雨夜被重新翻开，刑警队长与当年唯一的目击者被迫再次面对真相。随着证据层层剥落，小城里每个人都在守护同一个秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20of%20a%20lone%20detective%20in%20a%20rain%20soaked%20harbor%20town%20at%20night%20deep%20navy%20blue%20tones%20with%20warm%20amber%20street%20lamps%20dramatic%20shadows%20film%20grain%20elegant%20minimal%20composition&width=600&height=900&seq=poster-longye&orientation=portrait",
    tags: ["年度悬疑", "犯罪档案", "口碑之作"],
    updatedAt: "2025-09-28",
  },
  {
    id: "xinghai-huisheng",
    title: "星海回声",
    year: 2024,
    type: "movie",
    region: "美国",
    genres: ["科幻", "冒险", "剧情"],
    rating: 8.9,
    heat: 9720,
    director: "Ethan Cole",
    cast: ["Mara Quinn", "Julian Reyes", "Ada Lin"],
    duration: "152分钟",
    status: "已上映",
    episodes: [],
    synopsis:
      "人类第一艘深空探测船在返航途中收到一段来自自身的求救信号。宇航员必须在记忆与现实的夹缝中，判断自己究竟是归来者，还是被复制的那一个。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20science%20fiction%20movie%20poster%20with%20an%20astronaut%20silhouette%20before%20a%20vast%20glowing%20nebula%20deep%20navy%20space%20and%20soft%20orange%20starlight%20minimal%20elegant%20composition%20film%20grain&width=600&height=900&seq=poster-xinghai&orientation=portrait",
    tags: ["硬科幻", "太空史诗", "年度必看"],
    updatedAt: "2025-08-14",
  },
  {
    id: "chaoxi-zhicheng",
    title: "潮汐之城",
    year: 2025,
    type: "movie",
    region: "中国香港",
    genres: ["爱情", "剧情", "文艺"],
    rating: 8.2,
    heat: 8610,
    director: "陈映岚",
    cast: ["何隽", "林知夏", "郑南"],
    duration: "116分钟",
    status: "已上映",
    episodes: [],
    synopsis:
      "台风季的渔港小城，两个多年未见的旧友因为一场葬礼重逢。潮水每日两次漫过码头，也把他们没能说出口的话一遍遍推回岸边。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20romantic%20drama%20poster%20two%20figures%20on%20a%20wet%20pier%20at%20dusk%20muted%20teal%20sea%20and%20warm%20orange%20sunset%20glow%20rain%20mist%20delicate%20nostalgic%20mood%20film%20photography&width=600&height=900&seq=poster-chaoxi&orientation=portrait",
    tags: ["文艺爱情", "港风", "夏日档"],
    updatedAt: "2025-07-22",
  },
  {
    id: "yiluxiangbei-xiating",
    title: "一路向北的夏天",
    year: 2024,
    type: "movie",
    region: "中国大陆",
    genres: ["青春", "剧情", "公路"],
    rating: 7.8,
    heat: 7420,
    director: "许听舟",
    cast: ["周时宇", "顾念", "白川"],
    duration: "108分钟",
    status: "已上映",
    episodes: [],
    synopsis:
      "高考结束后的第三天，四个年轻人开着一辆旧面包车一路向北。他们以为在寻找一场日出，其实是在为即将散场的青春找一个告别的方式。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20coming%20of%20age%20road%20movie%20poster%20old%20van%20on%20an%20empty%20highway%20at%20golden%20sunset%20warm%20amber%20sky%20and%20deep%20blue%20mountains%20youthful%20free%20mood%20film%20grain&width=600&height=900&seq=poster-yilu&orientation=portrait",
    tags: ["青春公路", "治愈", "毕业季"],
    updatedAt: "2025-06-02",
  },
  {
    id: "chenmo-de-zhengci",
    title: "沉默的证词",
    year: 2023,
    type: "movie",
    region: "韩国",
    genres: ["悬疑", "剧情", "法庭"],
    rating: 8.5,
    heat: 8130,
    director: "Kim Ha-jun",
    cast: ["Seo Yuna", "Park Ji-hoon", "Lee Chan"],
    duration: "124分钟",
    status: "已上映",
    episodes: [],
    synopsis:
      "一名手语翻译被卷入一桩没有证人愿意开口的凶案。她必须在法庭的沉默里，替那些无法发声的人说完最后一句证词。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20courtroom%20thriller%20poster%20single%20woman%20under%20a%20narrow%20beam%20of%20light%20in%20a%20dark%20hall%20charcoal%20navy%20tones%20with%20one%20warm%20orange%20accent%20tense%20quiet%20atmosphere&width=600&height=900&seq=poster-chenmo&orientation=portrait",
    tags: ["法庭悬疑", "韩国电影", "高口碑"],
    updatedAt: "2025-05-18",
  },
  {
    id: "shaqiu-zhiwai",
    title: "沙丘之外",
    year: 2025,
    type: "movie",
    region: "美国",
    genres: ["科幻", "史诗", "冒险"],
    rating: 8.1,
    heat: 9180,
    director: "Lucas Vane",
    cast: ["Iris Bennett", "Omar Haddad", "Noah Frost"],
    duration: "164分钟",
    status: "热映中",
    episodes: [],
    synopsis:
      "沙海尽头的绿洲传说流传了百年，一支测绘队带着最后一张旧地图出发。他们要证明的不是传说，而是人类仍然愿意为一个不确定的答案走很远。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20desert%20epic%20poster%20lone%20traveler%20on%20a%20golden%20dune%20under%20a%20vast%20deep%20blue%20sky%20sand%20haze%20warm%20orange%20dust%20light%20grand%20minimal%20composition&width=600&height=900&seq=poster-shaqiu&orientation=portrait",
    tags: ["视觉奇观", "史诗", "IMAX"],
    updatedAt: "2025-10-02",
  },
  {
    id: "shan-nabian-youzuo-cheng",
    title: "山那边有座城",
    year: 2024,
    type: "movie",
    region: "中国大陆",
    genres: ["剧情", "家庭", "现实"],
    rating: 8.4,
    heat: 6980,
    director: "李宗宇",
    cast: ["张素芬", "马骁", "何小满"],
    duration: "132分钟",
    status: "已上映",
    episodes: [],
    synopsis:
      "一位母亲在山区小学教了三十年书，儿子却在城里做着与她完全相反的选择。一次意外的返乡，让两代人的坚持第一次被彼此看见。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20family%20drama%20poster%20small%20mountain%20school%20with%20warm%20window%20light%20at%20dusk%20soft%20misty%20blue%20ridges%20and%20amber%20lanterns%20tender%20restrained%20mood%20film%20grain&width=600&height=900&seq=poster-shannabian&orientation=portrait",
    tags: ["现实主义", "家庭", "感动"],
    updatedAt: "2025-04-09",
  },
  {
    id: "wuye-lieche",
    title: "午夜列车",
    year: 2023,
    type: "movie",
    region: "英国",
    genres: ["惊悚", "悬疑"],
    rating: 7.9,
    heat: 6240,
    director: "Oliver Grange",
    cast: ["Nina Hall", "Tom Searle", "Ruth Adeyemi"],
    duration: "104分钟",
    status: "已上映",
    episodes: [],
    synopsis:
      "末班列车驶出站台后，乘客发现窗外的站名全都不存在。当列车第七次经过同一座隧道，有人终于记起自己为何会在这里。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20suspense%20thriller%20poster%20last%20night%20train%20window%20with%20fog%20and%20dim%20amber%20lights%20dark%20navy%20corridor%20silhouette%20of%20a%20passenger%20mysterious%20cold%20mood%20film%20grain&width=600&height=900&seq=poster-wuye&orientation=portrait",
    tags: ["悬疑惊悚", "密室", "英伦"],
    updatedAt: "2025-03-11",
  },
  {
    id: "qiri-zhijian",
    title: "七日之间",
    year: 2025,
    type: "movie",
    region: "日本",
    genres: ["剧情", "奇幻", "治愈"],
    rating: 8.6,
    heat: 8060,
    director: "Aoi Nakamura",
    cast: ["Sato Haru", "Kobayashi Mei", "Ito Ren"],
    duration: "121分钟",
    status: "已上映",
    episodes: [],
    synopsis:
      "一间旧书店的店主获得七天时间，可以回到任何一位客人最想说抱歉的那一天。他一边修补别人的遗憾，一边回避自己最想回去的那一刻。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20japanese%20fantasy%20drama%20poster%20cozy%20old%20bookshop%20with%20floating%20paper%20and%20warm%20lamp%20glow%20deep%20indigo%20evening%20outside%20window%20gentle%20magical%20atmosphere%20film%20grain&width=600&height=900&seq=poster-qiri&orientation=portrait",
    tags: ["治愈奇幻", "日本电影", "催泪"],
    updatedAt: "2025-09-06",
  },
  {
    id: "wudu-mian",
    title: "雾都谜案",
    year: 2025,
    type: "tv",
    region: "中国大陆",
    genres: ["悬疑", "年代", "犯罪"],
    rating: 8.8,
    heat: 9930,
    director: "沈砚",
    cast: ["陆行舟", "温如瑾", "宋渠"],
    duration: "45分钟/集",
    status: "全12集",
    totalEpisodes: 12,
    episodes: [
      { no: 1, title: "雾起时分", duration: "45分钟", synopsis: "码头浮起一具无名尸，巡捕房接到一封没有落款的举报信。" },
      { no: 2, title: "第七码头", duration: "46分钟", synopsis: "证物清单上少了一件东西，而唯一经手人已经三天没回家。" },
      { no: 3, title: "旧照相馆", duration: "44分钟", synopsis: "一张合影把三个毫无关系的名字连到了同一条街。" },
      { no: 4, title: "雨夜来客", duration: "47分钟", synopsis: "自称死者旧友的男人登门，带来十二年前的船票。" },
      { no: 5, title: "账本之缺", duration: "45分钟", synopsis: "商会账本缺了一页，缺的那页恰好记着全城的雾。" },
      { no: 6, title: "无字之碑", duration: "46分钟", synopsis: "墓园里那块没有名字的石碑，被人连夜换掉了。" },
      { no: 7, title: "灯下黑", duration: "48分钟", synopsis: "所有线索都指向巡捕房内部，信任开始崩塌。" },
      { no: 8, title: "最后一封信", duration: "46分钟", synopsis: "举报人终于现身，却要求先听完一个故事。" },
    ],
    synopsis:
      "上世纪三十年代的雾都，巡捕房探长接手一桩码头沉尸案。雾气掩盖的不仅是凶手，还有整座城市心照不宣的默契。随着调查推进，他发现自己最信任的同僚，正是当年那场大火的第一目击者。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20period%20mystery%20series%20poster%20foggy%201930s%20harbor%20city%20with%20vintage%20streetlamps%20and%20a%20detective%20in%20a%20long%20coat%20deep%20navy%20mist%20warm%20amber%20highlights%20film%20grain&width=600&height=900&seq=poster-wudu&orientation=portrait",
    tags: ["年代悬疑", "本格推理", "高分剧集"],
    updatedAt: "2025-10-11",
  },
  {
    id: "women-de-shinian",
    title: "我们的十年",
    year: 2024,
    type: "tv",
    region: "中国大陆",
    genres: ["都市", "情感", "群像"],
    rating: 8.3,
    heat: 8740,
    director: "高唯",
    cast: ["许知言", "贺兰", "程亦"],
    duration: "42分钟/集",
    status: "全30集",
    totalEpisodes: 30,
    episodes: [],
    synopsis:
      "五个大学室友毕业十年后重聚，在同一张桌子上摊开了各自没能说出口的十年。有人功成名就，有人重新开始，而他们共同的青春只剩下一间快要拆迁的老房子。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20urban%20ensemble%20drama%20poster%20five%20friends%20silhouettes%20on%20a%20rooftop%20overlooking%20a%20city%20at%20blue%20hour%20warm%20orange%20window%20lights%20nostalgic%20warm%20tone&width=600&height=900&seq=poster-shinian&orientation=portrait",
    tags: ["都市群像", "现实情感", "下饭剧"],
    updatedAt: "2025-09-19",
  },
  {
    id: "shenhai-dangan",
    title: "深海档案",
    year: 2025,
    type: "tv",
    region: "美国",
    genres: ["科幻", "悬疑", "惊悚"],
    rating: 8.9,
    heat: 9610,
    director: "Adrian Wells",
    cast: ["Clara Voss", "Miles Grant", "Yara Nasser"],
    duration: "52分钟/集",
    status: "全10集",
    totalEpisodes: 10,
    episodes: [
      { no: 1, title: "下潜", duration: "52分钟", synopsis: "深海观测站失联七十二小时后，第一批维修人员抵达。" },
      { no: 2, title: "第九层", duration: "51分钟", synopsis: "图纸上不存在的第九层，有人在里面留下咖啡杯。" },
      { no: 3, title: "回声定位", duration: "53分钟", synopsis: "声呐捕捉到规律的敲击，节奏与三年前的求救信号相同。" },
      { no: 4, title: "低压", duration: "50分钟", synopsis: "氧气告急，队员开始怀疑有人故意延长任务时间。" },
      { no: 5, title: "休眠舱", duration: "54分钟", synopsis: "打开的休眠舱里躺着一个不该出现在这里的人。" },
      { no: 6, title: "黑水", duration: "52分钟", synopsis: "断电的十分钟内，监控记录被完整地覆盖了。" },
      { no: 7, title: "母船", duration: "53分钟", synopsis: "母船发来撤离命令，署名却是三年前已故的站长。" },
      { no: 8, title: "上浮", duration: "55分钟", synopsis: "真相随压力一起释放，海面之上同样没有安全区。" },
    ],
    synopsis:
      "深海观测站突然失联，一支由工程师与心理学家组成的队伍奉命下潜检修。他们发现站内所有记录都停在同一个时间点，而这支队伍的名单里，本身就有一个多余的人。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20underwater%20science%20fiction%20series%20poster%20deep%20sea%20research%20station%20glowing%20in%20dark%20navy%20water%20single%20warm%20orange%20light%20claustrophobic%20mystery%20mood&width=600&height=900&seq=poster-shenhai&orientation=portrait",
    tags: ["深海科幻", "密室悬疑", "高分美剧"],
    updatedAt: "2025-10-08",
  },
  {
    id: "jinghua-jiumeng",
    title: "京华旧梦",
    year: 2024,
    type: "tv",
    region: "中国大陆",
    genres: ["古装", "剧情", "家国"],
    rating: 8.1,
    heat: 8950,
    director: "顾长明",
    cast: ["沈书宁", "裴元", "柳拂衣"],
    duration: "45分钟/集",
    status: "全40集",
    totalEpisodes: 40,
    episodes: [],
    synopsis:
      "旧都望族在一夜之间败落，唯一幸存的女儿带着一本残谱北上。她要用十年时间，把被抹去的名字一个个写回族谱，也写回这座城的记忆里。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20chinese%20period%20drama%20poster%20elegant%20woman%20in%20flowing%20silk%20before%20ancient%20palace%20roofs%20at%20dusk%20deep%20navy%20sky%20warm%20amber%20lanterns%20ink%20painting%20texture&width=600&height=900&seq=poster-jinghua&orientation=portrait",
    tags: ["古装群像", "家国叙事", "精良制作"],
    updatedAt: "2025-08-30",
  },
  {
    id: "niguang-erxing",
    title: "逆光而行",
    year: 2025,
    type: "tv",
    region: "韩国",
    genres: ["犯罪", "剧情", "动作"],
    rating: 8.7,
    heat: 9320,
    director: "Jung Min-seo",
    cast: ["Han Ji-woo", "Baek Seo-jin", "Choi Min"],
    duration: "60分钟/集",
    status: "全12集",
    totalEpisodes: 12,
    episodes: [
      { no: 1, title: "出狱", duration: "60分钟", synopsis: "服刑十年的人走出大门，接他的人却不是约好的那一个。" },
      { no: 2, title: "旧账", duration: "58分钟", synopsis: "一笔十年前的账，突然出现在当天的新闻里。" },
      { no: 3, title: "第三个人", duration: "61分钟", synopsis: "当年的目击者有三个人，活下来的只有两个。" },
      { no: 4, title: "证物室", duration: "59分钟", synopsis: "被封存的证物被人打开过，指纹属于内部人员。" },
      { no: 5, title: "家宴", duration: "62分钟", synopsis: "一场家宴上，所有人都在等一个人先开口。" },
      { no: 6, title: "逆光", duration: "60分钟", synopsis: "追诉期只剩三天，他选择站到最亮的地方。" },
      { no: 7, title: "对峙", duration: "63分钟", synopsis: "两个同样失去一切的人，在天台上第一次坦白。" },
      { no: 8, title: "天亮之后", duration: "64分钟", synopsis: "真相被公开，代价也随之而来。" },
    ],
    synopsis:
      "一个被错判的男人出狱后只想做一件事：找到当年替自己作证的人。他沿着一条不断被抹去的线索逆行，逐渐走进权力与金钱交织的暗处，也重新认识了那个曾经放弃自己的自己。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20crime%20drama%20series%20poster%20lone%20man%20walking%20out%20of%20prison%20gate%20into%20harsh%20backlight%20deep%20navy%20shadows%20warm%20orange%20sunlight%20flare%20gritty%20atmosphere&width=600&height=900&seq=poster-niguang&orientation=portrait",
    tags: ["犯罪悬疑", "韩剧", "强反转"],
    updatedAt: "2025-10-05",
  },
  {
    id: "xiaocheng-shiguang",
    title: "小城食光",
    year: 2024,
    type: "tv",
    region: "中国大陆",
    genres: ["治愈", "家庭", "美食"],
    rating: 8.5,
    heat: 7260,
    director: "温言",
    cast: ["罗青禾", "老陈", "林小满"],
    duration: "35分钟/集",
    status: "全20集",
    totalEpisodes: 20,
    episodes: [],
    synopsis:
      "接手外婆小面馆的女孩发现，每一碗面的浇头背后都藏着一个熟客的故事。她一边学着把汤熬好，一边慢慢学会把日子过慢一点。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20healing%20food%20drama%20poster%20small%20noodle%20shop%20at%20evening%20with%20steam%20rising%20warm%20amber%20lantern%20light%20deep%20blue%20street%20outside%20cozy%20nostalgic%20mood&width=600&height=900&seq=poster-shiguang&orientation=portrait",
    tags: ["治愈美食", "小城故事", "深夜必看"],
    updatedAt: "2025-07-12",
  },
  {
    id: "baise-shiyanshi",
    title: "白色实验室",
    year: 2023,
    type: "tv",
    region: "日本",
    genres: ["医疗", "悬疑", "职场"],
    rating: 8.2,
    heat: 6510,
    director: "Mori Kazuki",
    cast: ["Aoki Sora", "Nakamura Riku", "Hoshino Emi"],
    duration: "48分钟/集",
    status: "全12集",
    totalEpisodes: 12,
    episodes: [],
    synopsis:
      "一所顶级医院的研究室连续出现异常病例，年轻医生在追查过程中发现，所有数据都完美得不正常。她必须在职业前途与病人生命之间做出选择。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20medical%20thriller%20poster%20sterile%20white%20laboratory%20corridor%20with%20one%20figure%20in%20a%20lab%20coat%20cool%20blue%20white%20light%20single%20warm%20amber%20warning%20lamp%20clinical%20tense%20mood&width=600&height=900&seq=poster-baise&orientation=portrait",
    tags: ["医疗悬疑", "日剧", "职场"],
    updatedAt: "2025-06-21",
  },
  {
    id: "bianjiexian",
    title: "边界线",
    year: 2025,
    type: "tv",
    region: "英国",
    genres: ["犯罪", "惊悚", "政治"],
    rating: 8.6,
    heat: 7980,
    director: "Harriet Doyle",
    cast: ["Sean Mercer", "Elena Kaur", "Owen Blake"],
    duration: "55分钟/集",
    status: "全8集",
    totalEpisodes: 8,
    episodes: [],
    synopsis:
      "边境小镇的警官在处理一起偷渡案时，发现名单上有一个本不该存在的人。随着调查深入，他意识自己脚下的这条边界，早已被双方默契地改写过。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20political%20thriller%20poster%20lonely%20border%20checkpoint%20at%20night%20in%20rain%20deep%20navy%20darkness%20and%20small%20warm%20orange%20headlights%20wide%20empty%20landscape%20tense%20quiet%20mood&width=600&height=900&seq=poster-bianjie&orientation=portrait",
    tags: ["政治惊悚", "英剧", "冷峻"],
    updatedAt: "2025-09-27",
  },
  {
    id: "xingchen-zhixia",
    title: "星辰之下",
    year: 2024,
    type: "tv",
    region: "中国大陆",
    genres: ["科幻", "爱情", "都市"],
    rating: 7.7,
    heat: 6890,
    director: "白易",
    cast: ["顾星野", "苏晚", "梁宸"],
    duration: "43分钟/集",
    status: "全30集",
    totalEpisodes: 30,
    episodes: [],
    synopsis:
      "天文台的两名年轻研究员在一次观测事故后，开始收到来自十年后的留言。他们试图改变一件注定发生的事，却发现每一次努力都让彼此靠得更近，也离分别更近。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20romantic%20science%20fiction%20series%20poster%20two%20silhouettes%20on%20an%20observatory%20roof%20under%20a%20starry%20deep%20navy%20sky%20soft%20orange%20telescope%20light%20dreamy%20atmosphere&width=600&height=900&seq=poster-xingchen&orientation=portrait",
    tags: ["科幻爱情", "青春", "星空美学"],
    updatedAt: "2025-05-30",
  },
  {
    id: "shengxian-duijue",
    title: "声线对决 第六季",
    year: 2025,
    type: "variety",
    region: "中国大陆",
    genres: ["音乐", "真人秀", "竞技"],
    rating: 8.4,
    heat: 9020,
    director: "方竞",
    cast: ["周牧", "林一诺", "阿岚"],
    duration: "95分钟/期",
    status: "更新至第8期",
    totalEpisodes: 8,
    episodes: [
      { no: 1, title: "盲选之夜", duration: "96分钟", synopsis: "本季首次采用全盲选，导师仅凭声音转身。" },
      { no: 2, title: "双人对唱", duration: "94分钟", synopsis: "抽签决定搭档，两组最强声线被迫同台。" },
      { no: 3, title: "城市民谣", duration: "95分钟", synopsis: "选手走进街头，把一座城市的声音写进歌里。" },
      { no: 4, title: "改编赛", duration: "98分钟", synopsis: "经典老歌限时改编，原唱亲临现场点评。" },
      { no: 5, title: "乐队合作", duration: "95分钟", synopsis: "与现场乐队即兴配合，失误不可重来。" },
      { no: 6, title: "半决赛", duration: "102分钟", synopsis: "六强诞生，一位热门选手意外出局。" },
    ],
    synopsis:
      "全新一季的声线对决把舞台搬进城市现场，导师与选手在真实场景中完成合作舞台。本季新增盲选与即兴改编环节，让每一次开口都成为一次冒险。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20music%20competition%20show%20poster%20singer%20silhouette%20under%20a%20single%20spotlight%20on%20a%20dark%20navy%20stage%20warm%20orange%20light%20beams%20and%20haze%20energetic%20modern%20composition&width=600&height=900&seq=poster-shengxian&orientation=portrait",
    tags: ["音乐竞技", "综艺", "话题不断"],
    updatedAt: "2025-10-12",
  },
  {
    id: "yiqiquluying",
    title: "一起去露营",
    year: 2025,
    type: "variety",
    region: "中国大陆",
    genres: ["户外", "真人秀", "治愈"],
    rating: 8.0,
    heat: 7640,
    director: "陈也",
    cast: ["许南", "安然", "小满"],
    duration: "80分钟/期",
    status: "更新至第6期",
    totalEpisodes: 6,
    episodes: [
      { no: 1, title: "出发之前", duration: "78分钟", synopsis: "六位嘉宾带着各自的装备，第一次见面。" },
      { no: 2, title: "山间第一夜", duration: "82分钟", synopsis: "搭帐篷失败三次后，他们决定先煮一锅面。" },
      { no: 3, title: "雨来了", duration: "80分钟", synopsis: "突降暴雨，营地临时转移，意外收获一场篝火。" },
      { no: 4, title: "湖边早餐", duration: "79分钟", synopsis: "有人五点起床只为拍一张湖面晨雾。" },
      { no: 5, title: "无信号区", duration: "81分钟", synopsis: "断网二十四小时，大家开始认真聊天。" },
    ],
    synopsis:
      "六位在城市里习惯了快节奏的嘉宾，用六期节目学一件简单的事：把帐篷搭好，把饭煮熟，把手机放下。没有剧本，只有天气和彼此。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20outdoor%20camping%20variety%20show%20poster%20glowing%20tent%20beside%20a%20lake%20at%20blue%20hour%20with%20campfire%20warm%20orange%20sparks%20deep%20navy%20mountains%20cozy%20serene%20atmosphere&width=600&height=900&seq=poster-luying&orientation=portrait",
    tags: ["治愈慢综艺", "户外", "解压"],
    updatedAt: "2025-09-14",
  },
  {
    id: "xiju-yanjiusuo",
    title: "喜剧研究所",
    year: 2024,
    type: "variety",
    region: "中国大陆",
    genres: ["喜剧", "真人秀"],
    rating: 8.2,
    heat: 7180,
    director: "马小川",
    cast: ["郭一鸣", "钱多", "白桃"],
    duration: "88分钟/期",
    status: "全12期",
    totalEpisodes: 12,
    episodes: [],
    synopsis:
      "十二组喜剧人进入研究所，每周围绕一个生活议题交出原创作品。没有安全牌，只有观众现场投票，笑声就是唯一的评分标准。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20comedy%20variety%20show%20poster%20vintage%20theatre%20stage%20with%20red%20curtain%20and%20single%20microphone%20warm%20amber%20spotlight%20deep%20navy%20shadows%20playful%20retro%20mood&width=600&height=900&seq=poster-xiju&orientation=portrait",
    tags: ["喜剧综艺", "原创", "下饭必备"],
    updatedAt: "2025-04-25",
  },
  {
    id: "chengshi-manyou",
    title: "城市漫游记",
    year: 2025,
    type: "variety",
    region: "中国大陆",
    genres: ["旅行", "纪实", "人文"],
    rating: 8.6,
    heat: 6560,
    director: "纪寻",
    cast: ["陆离", "苏禾"],
    duration: "50分钟/期",
    status: "全8期",
    totalEpisodes: 8,
    episodes: [],
    synopsis:
      "两位主持人用步行丈量八座城市，不打卡地标，只走进菜市场、旧书店和末班公交。每一期都是一封写给普通生活的长信。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20travel%20documentary%20poster%20narrow%20old%20city%20alley%20at%20dusk%20with%20warm%20shop%20lights%20and%20deep%20navy%20sky%20two%20walking%20figures%20seen%20from%20behind%20nostalgic%20humanist%20mood&width=600&height=900&seq=poster-manyou&orientation=portrait",
    tags: ["人文纪实", "旅行", "慢节奏"],
    updatedAt: "2025-08-07",
  },
  {
    id: "yunhai-zhishang",
    title: "云海之上",
    year: 2025,
    type: "anime",
    region: "日本",
    genres: ["奇幻", "冒险", "成长"],
    rating: 9.0,
    heat: 9460,
    director: "Hayashi Kenta",
    cast: ["Morita Aoi", "Sakura Rin", "Ogawa Yuu"],
    duration: "24分钟/集",
    status: "更新至第8话",
    totalEpisodes: 12,
    episodes: [
      { no: 1, title: "会飞的船", duration: "24分钟", synopsis: "少女在废弃港口发现一艘只对风说话的小船。" },
      { no: 2, title: "云图", duration: "24分钟", synopsis: "老船长交给她一张会随天气变化的航海图。" },
      { no: 3, title: "第一座浮岛", duration: "23分钟", synopsis: "浮岛居民不欢迎外来者，除非她能回答一个问题。" },
      { no: 4, title: "下落的风", duration: "24分钟", synopsis: "风突然停了，所有船困在同一片云里。" },
      { no: 5, title: "天空之市", duration: "25分钟", synopsis: "传说中的集市只开一夜，交换的是记忆。" },
      { no: 6, title: "旧航线", duration: "24分钟", synopsis: "地图上浮现一条被抹去的航线，尽头是她的故乡。" },
      { no: 7, title: "逆风", duration: "24分钟", synopsis: "为了救回同伴，她第一次独自掌舵。" },
      { no: 8, title: "云海尽头", duration: "25分钟", synopsis: "云层裂开一道缝，露出从未有人见过的天空。" },
    ],
    synopsis:
      "在云海覆盖的世界里，地面只是传说。少女继承了一艘会随风思考的旧船，带着一张不断改写的云图出发，去寻找那座据说只存在于风里的故乡。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20anime%20adventure%20poster%20young%20girl%20standing%20on%20a%20flying%20wooden%20boat%20above%20a%20sea%20of%20clouds%20deep%20navy%20sky%20warm%20orange%20sunrise%20glow%20hand%20painted%20style&width=600&height=900&seq=poster-yunhai&orientation=portrait",
    tags: ["奇幻冒险", "新番", "高开分"],
    updatedAt: "2025-10-13",
  },
  {
    id: "jixie-jiyuan",
    title: "机械纪元",
    year: 2024,
    type: "anime",
    region: "日本",
    genres: ["科幻", "机战", "剧情"],
    rating: 8.8,
    heat: 8820,
    director: "Kuroda Shin",
    cast: ["Ishida Kai", "Mizuki Hana", "Fujita Ryo"],
    duration: "25分钟/集",
    status: "全24话",
    totalEpisodes: 24,
    episodes: [],
    synopsis:
      "人类与机械生命体的停战协议维持了十七年。一名维修少年在废弃战场唤醒了一台会做梦的机甲，而它梦见的，正是下一场战争的开始。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20mecha%20anime%20poster%20rusted%20giant%20robot%20kneeling%20in%20a%20ruined%20city%20at%20dusk%20deep%20navy%20storm%20sky%20warm%20orange%20reactor%20glow%20epic%20wistful%20mood&width=600&height=900&seq=poster-jixie&orientation=portrait",
    tags: ["机甲科幻", "高燃", "完结补番"],
    updatedAt: "2025-07-04",
  },
  {
    id: "shanhai-huijuan",
    title: "山海绘卷",
    year: 2025,
    type: "anime",
    region: "中国大陆",
    genres: ["国风", "奇幻", "冒险"],
    rating: 8.9,
    heat: 9350,
    director: "墨白",
    cast: ["苏羽", "姜辞", "阿吉"],
    duration: "22分钟/集",
    status: "更新至第6话",
    totalEpisodes: 12,
    episodes: [
      { no: 1, title: "落笔成山", duration: "22分钟", synopsis: "少年画师随手一勾，画里的山真的长了出来。" },
      { no: 2, title: "会走的墨", duration: "22分钟", synopsis: "墨迹自己爬出纸外，留下一串细小的脚印。" },
      { no: 3, title: "山市", duration: "21分钟", synopsis: "深夜集市里，所有摊主都不是人。" },
      { no: 4, title: "无字碑", duration: "23分钟", synopsis: "碑上空白一片，却有人对着它哭了整夜。" },
      { no: 5, title: "画中人", duration: "22分钟", synopsis: "他画了十年的女孩，在一场雨后走出画卷。" },
      { no: 6, title: "收卷", duration: "23分钟", synopsis: "卷轴将合，他必须选择留下哪一页世界。" },
    ],
    synopsis:
      "传说中的山海绘卷能将被画下的东西变成真实。少年画师偶然得到一支旧笔，从此每落一笔都牵动一界生灵。他必须学会的不是画技，而是取舍。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20chinese%20ink%20painting%20fantasy%20anime%20poster%20young%20painter%20with%20a%20brush%20before%20floating%20mountains%20and%20mythical%20creatures%20deep%20navy%20ink%20wash%20warm%20golden%20mist%20elegant%20oriental%20composition&width=600&height=900&seq=poster-shanhai&orientation=portrait",
    tags: ["国风动画", "神话", "画面绝美"],
    updatedAt: "2025-10-10",
  },
  {
    id: "xiaomao-yueliang",
    title: "小猫与月亮",
    year: 2024,
    type: "anime",
    region: "日本",
    genres: ["治愈", "日常", "奇幻"],
    rating: 8.7,
    heat: 7040,
    director: "Ueda Miyu",
    cast: ["Kawai Nao", "Suzuki Ren"],
    duration: "12分钟/集",
    status: "全24话",
    totalEpisodes: 24,
    episodes: [],
    synopsis:
      "一只住在屋顶的小猫每晚都会和月亮聊天。月亮会告诉它白天发生的事，它则把人间的小烦恼一件件讲给月亮听。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20gentle%20anime%20poster%20small%20cat%20sitting%20on%20a%20tiled%20rooftop%20looking%20at%20a%20huge%20warm%20orange%20moon%20deep%20navy%20night%20sky%20with%20soft%20stars%20cozy%20whimsical%20mood&width=600&height=900&seq=poster-xiaomao&orientation=portrait",
    tags: ["治愈日常", "短篇动画", "睡前必看"],
    updatedAt: "2025-06-13",
  },
  {
    id: "jiye-zhuiguang",
    title: "极夜追光",
    year: 2023,
    type: "anime",
    region: "美国",
    genres: ["动画", "冒险", "家庭"],
    rating: 8.3,
    heat: 5920,
    director: "Grace Holloway",
    cast: ["Lily Brooks", "Dean Park"],
    duration: "96分钟",
    status: "已上映",
    episodes: [],
    synopsis:
      "在一年只有一次日出的极北小镇，兄妹俩为了替生病的爷爷找回极光，踏上了一段横穿冰原的旅程。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20animated%20family%20adventure%20poster%20two%20children%20with%20a%20sled%20on%20a%20snowfield%20under%20green%20and%20deep%20navy%20aurora%20sky%20warm%20orange%20lantern%20light%20wonder%20and%20scale&width=600&height=900&seq=poster-jiye&orientation=portrait",
    tags: ["合家欢", "动画电影", "极光"],
    updatedAt: "2025-02-20",
  },
  {
    id: "shaonian-jianxinlu",
    title: "少年剑心录",
    year: 2025,
    type: "anime",
    region: "中国大陆",
    genres: ["热血", "武侠", "成长"],
    rating: 8.5,
    heat: 8290,
    director: "江远",
    cast: ["叶知秋", "白小楼", "段青"],
    duration: "23分钟/集",
    status: "更新至第6话",
    totalEpisodes: 12,
    episodes: [
      { no: 1, title: "出剑", duration: "23分钟", synopsis: "镇上的打铁少年第一次握住真正的剑。" },
      { no: 2, title: "第一场雨", duration: "23分钟", synopsis: "他在雨里输了第一场比试，也第一次笑。" },
      { no: 3, title: "无名师父", duration: "24分钟", synopsis: "扫地老人随手一剑，割断了整片竹林的叶。" },
      { no: 4, title: "山门", duration: "23分钟", synopsis: "上山的路只有一条，下山的路却有很多。" },
      { no: 5, title: "旧剑", duration: "23分钟", synopsis: "剑鞘里藏着的不是剑，是一封信。" },
      { no: 6, title: "少年行", duration: "24分钟", synopsis: "他带着一柄断剑，走向更大的江湖。" },
    ],
    synopsis:
      "打铁少年的剑第一次出鞘，是为了替小镇挡下一场不该来的比试。从那天起，他带着一柄还没开刃的剑，走进了自己从未想象过的江湖。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20chinese%20wuxia%20anime%20poster%20young%20swordsman%20holding%20a%20thin%20blade%20in%20a%20misty%20bamboo%20forest%20deep%20navy%20blue%20shadows%20warm%20amber%20sunlight%20through%20leaves%20dynamic%20elegant%20composition&width=600&height=900&seq=poster-jianxin&orientation=portrait",
    tags: ["国漫", "武侠热血", "新番"],
    updatedAt: "2025-10-09",
  },
];